var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import * as ReactDOM from "react-dom";
import { ResponsivityManager } from "survey-core";
import { attachKey2click, ReactElementFactory, SurveyElementBase, SvgIcon } from "survey-react-ui";
var TabbedMenuComponent = /** @class */ (function (_super) {
    __extends(TabbedMenuComponent, _super);
    function TabbedMenuComponent(props) {
        var _this = _super.call(this, props) || this;
        _this.rootRef = React.createRef();
        return _this;
    }
    Object.defineProperty(TabbedMenuComponent.prototype, "model", {
        get: function () {
            return this.props.model;
        },
        enumerable: false,
        configurable: true
    });
    TabbedMenuComponent.prototype.getStateElement = function () {
        return this.model;
    };
    TabbedMenuComponent.prototype.renderElement = function () {
        var items = this.model.renderedActions.map(function (item) { return React.createElement(TabbedMenuItemWrapper, { item: item, key: item.renderedId }); });
        return (React.createElement("div", { ref: this.rootRef, className: "svc-tabbed-menu", role: "tablist" }, items));
    };
    TabbedMenuComponent.prototype.componentDidMount = function () {
        _super.prototype.componentDidMount.call(this);
        var container = this.rootRef.current;
        if (!container)
            return;
        this.manager = new ResponsivityManager(container, this.model);
    };
    TabbedMenuComponent.prototype.componentWillUnmount = function () {
        this.manager && (this.manager.dispose());
        _super.prototype.componentWillUnmount.call(this);
    };
    return TabbedMenuComponent;
}(SurveyElementBase));
export { TabbedMenuComponent };
var TabbedMenuItemWrapper = /** @class */ (function (_super) {
    __extends(TabbedMenuItemWrapper, _super);
    function TabbedMenuItemWrapper(props) {
        var _this = _super.call(this, props) || this;
        _this.ref = React.createRef();
        return _this;
    }
    Object.defineProperty(TabbedMenuItemWrapper.prototype, "item", {
        get: function () {
            return this.props.item;
        },
        enumerable: false,
        configurable: true
    });
    TabbedMenuItemWrapper.prototype.getStateElement = function () {
        return this.item;
    };
    TabbedMenuItemWrapper.prototype.renderElement = function () {
        var css = "svc-tabbed-menu-item-container";
        if (this.item.css) {
            css += " " + this.item.css;
        }
        css += (!this.item.isVisible ? " sv-action--hidden" : "");
        var component = ReactElementFactory.Instance.createElement(this.item.component || "svc-tabbed-menu-item", { item: this.item });
        return (React.createElement("span", { key: this.item.id, className: css, ref: this.ref },
            React.createElement("div", { className: "sv-action__content" }, component)));
    };
    TabbedMenuItemWrapper.prototype.componentDidMount = function () {
        var _this = this;
        _super.prototype.componentDidMount.call(this);
        this.item.updateModeCallback = function (mode, callback) {
            queueMicrotask(function () {
                if (ReactDOM["flushSync"]) {
                    ReactDOM["flushSync"](function () {
                        _this.item.mode = mode;
                    });
                }
                else {
                    _this.item.mode = mode;
                }
                queueMicrotask(function () {
                    callback(mode, _this.ref.current);
                });
            });
        };
        this.item.afterRender();
    };
    TabbedMenuItemWrapper.prototype.componentWillUnmount = function () {
        _super.prototype.componentWillUnmount.call(this);
        this.item.updateModeCallback = undefined;
    };
    return TabbedMenuItemWrapper;
}(SurveyElementBase));
var TabbedMenuItemComponent = /** @class */ (function (_super) {
    __extends(TabbedMenuItemComponent, _super);
    function TabbedMenuItemComponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(TabbedMenuItemComponent.prototype, "item", {
        get: function () {
            return this.props.item;
        },
        enumerable: false,
        configurable: true
    });
    TabbedMenuItemComponent.prototype.getStateElement = function () {
        return this.item;
    };
    TabbedMenuItemComponent.prototype.render = function () {
        var item = this.item;
        return (attachKey2click(React.createElement("div", { role: "tab", id: "tab-" + item.id, "aria-selected": item.active, "aria-controls": "scrollableDiv-" + item.id, className: item.getRootCss(), onClick: function () { return item.action(item); } },
            item.hasTitle ? React.createElement("span", { className: item.getTitleCss() }, item.title) : null,
            item.hasIcon ? React.createElement(SvgIcon, { iconName: item.iconName, className: item.getIconCss(), size: "auto", title: item.tooltip || item.title }) : null)));
    };
    return TabbedMenuItemComponent;
}(SurveyElementBase));
export { TabbedMenuItemComponent };
ReactElementFactory.Instance.registerElement("svc-tabbed-menu-item", function (props) {
    return React.createElement(TabbedMenuItemComponent, props);
});
export default TabbedMenuComponent;
